import React, { FC, KeyboardEvent, MouseEvent } from 'react';
import { PromoRateCode } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { SpecialCodes, StyledTextInput } from './PromoCodeInput.styles';

export type PromoRateCodeInputProps = {
  acceptPromoRateCode?: boolean;
  onApplyPromoRateCode?: (code: string) => void;
  promoRateCode?: PromoRateCode;
  onFiltersApply: (event: KeyboardEvent<HTMLElement> | MouseEvent<HTMLElement>) => void;
};

export const PromoRateCodeInput: FC<PromoRateCodeInputProps> = ({
  promoRateCode,
  acceptPromoRateCode = false,
  onApplyPromoRateCode = () => {},
  onFiltersApply,
}) => {
  const { t } = useTranslations();
  const onApply = (e: KeyboardEvent<HTMLElement>) => {
    onFiltersApply(e);
  };
  return acceptPromoRateCode ? (
    <>
      <SpecialCodes>
        <StyledTextInput
          isRequired={false}
          value={promoRateCode}
          label={t('room.specialCodes')}
          id="promo-code-input"
          placeholder={t('room.specialCodes')}
          onChange={(event) => {
            onApplyPromoRateCode(event.currentTarget.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onApply(e);
          }}
        />
      </SpecialCodes>
    </>
  ) : null;
};
